import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireRole = null, requireTD = false, requireMember = false }) => {
  const { user, loading, isAuthenticated, isTournamentDirector, isMember } = useAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check role-based access
  if (requireTD && !isTournamentDirector()) {
    return (
      <div className="access-denied">
        <h2>Access Denied</h2>
        <p>Tournament Director access required.</p>
        <button onClick={() => window.history.back()}>Go Back</button>
      </div>
    );
  }

  if (requireMember && !isMember()) {
    return (
      <div className="access-denied">
        <h2>Access Denied</h2>
        <p>Member access required.</p>
        <button onClick={() => window.history.back()}>Go Back</button>
      </div>
    );
  }

  if (requireRole && user.role !== requireRole) {
    return (
      <div className="access-denied">
        <h2>Access Denied</h2>
        <p>Required role: {requireRole}</p>
        <button onClick={() => window.history.back()}>Go Back</button>
      </div>
    );
  }

  // Render children if all checks pass
  return children;
};

export default ProtectedRoute;